function mapToObject(map) {
  var obj = {};

  if (map) {
    map.forEach(function (v, k) {
      if (typeof v === 'string' || typeof v === 'number') {
        obj[k] = v;
      }
    });
  }

  return obj;
}

export { mapToObject };
//# sourceMappingURL=mapToObject.esm.js.map
